// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  text-transform: capitalize;
}

.header-btn {
  display: flex;
  justify-content: flex-end;
}
.header-btn .bsg-close-button {
  background: transparent;
}
.header-btn ion-icon {
  width: 19px;
}

.wrapper {
  color: var(--menu-modal-text-color);
  padding: 30px 15px 15px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.separator {
  width: 100%;
  margin: 16px 0;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
  color: var(--ion-color-secondary);
}

ion-row,
button {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  margin-top: 12px;
  font-size: 26px;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.email {
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
  color: var(--ion-color-secondary);
  padding-bottom: 15px;
  border-bottom: 1px solid #d9d9d9;
}

a,
button {
  text-decoration: none;
  color: black;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  font-size: 20px;
  color: var(--ion-color-secondary);
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-lang div.selected span {
  color: white;
}

.footer-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-block .lang-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer-block .lang-block .lang-item {
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  box-shadow: 0px 3.09px 11.57px 0px rgba(13, 71, 161, 0.1490196078);
  margin-right: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  background: white;
}
.footer-block .lang-block .lang-item ion-icon {
  width: 18px;
  height: 18px;
  padding: 0px;
}
.footer-block .lang-block .lang-item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-primary);
  margin-top: 5px;
  transition: color 0.3s ease;
}
.footer-block .lang-block .lang-item.selected {
  background: var(--ion-color-primary);
}
.footer-block .lang-block .lang-item.selected h3 {
  color: white;
}
.footer-block .logout {
  zoom: 1.5;
  margin: 0px;
}

.bsg-menu-nav,
.bsg-legal-nav {
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
}
.bsg-menu-nav button,
.bsg-legal-nav button {
  background: transparent;
}

.bsg-menu-item {
  display: flex;
  align-items: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss"],"names":[],"mappings":"AACA;EACC,kBAAA;EACA,0BAAA;AAAD;;AAEA;EACC,aAAA;EACA,yBAAA;AACD;AAAC;EACC,uBAAA;AAEF;AAAC;EACC,WAAA;AAEF;;AAIA;EACC,mCAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AADD;;AAIA;EACC,WAAA;EACA,cAAA;AADD;;AAIA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AADD;;AAIA;EACC,YAAA;EACA,kBAAA;EACA,iCAAA;AADD;;AAIA;;EAEC,mBAAA;EACA,YAAA;EACA,eAAA;AADD;;AAIA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,oCAAA;AADD;;AAGA;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,iCAAA;EACA,oBAAA;EACA,gCAAA;AAAD;;AAGA;;EAEC,qBAAA;EACA,YAAA;AAAD;;AAGA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AAAD;;AAEA;EACC,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACD;;AACA;EACC,eAAA;EACA,iCAAA;AAED;;AACA;EACC,qBAAA;AAED;;AAAA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAGD;;AADA;EACC,SAAA;AAID;;AADA;EACC,eAAA;AAID;;AAFA;EACC,YAAA;AAKD;;AAFA;EACC,qBAAA;AAKD;;AAFA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAKD;;AAFA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAKD;AAHC;EACC,iBAAA;AAKF;AAHC;EACC,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAKF;AAJE;EACC,yBAAA;EACA,0BAAA;EACA,+BAAA;AAMH;AAFE;EAIC,oCAAA;EACA,YAAA;AACH;AALG;EACC,YAAA;AAOJ;;AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAGD;AAFC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;AAIF;AAHE;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kEAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;EAMA,iBAAA;AAAH;AALG;EACC,WAAA;EACA,YAAA;EACA,YAAA;AAOJ;AAJG;EACC,oCAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,2BAAA;AAMJ;AAHG;EACC,oCAAA;AAKJ;AAJI;EACC,YAAA;AAML;AADC;EACC,SAAA;EACA,WAAA;AAGF;;AAAA;;EAEC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AAGD;AAFC;;EACC,uBAAA;AAKF;;AAFA;EACC,aAAA;EACA,mBAAA;AAKD","sourcesContent":["@import '../../../theme/mixins';\napp-menu-modal {\n\tposition: relative;\n\ttext-transform: capitalize;\n}\n.header-btn {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\t.bsg-close-button {\n\t\tbackground: transparent;\n\t}\n\tion-icon {\n\t\twidth: 19px;\n\t\t// right: 5px ;\n\t\t// top: 10px;\n\t\t// position: absolute;\n\t}\n}\n.wrapper {\n\tcolor: var(--menu-modal-text-color);\n\tpadding: 30px 15px 15px 20px;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.separator {\n\twidth: 100%;\n\tmargin: 16px 0;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n\tcolor: var(--ion-color-secondary);\n}\n\nion-row,\nbutton {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\n.name {\n\tmargin: 0px;\n\tmargin-top: 12px;\n\tfont-size: 26px;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n}\n.email {\n\tmargin: 0px;\n\tfont-size: 14px;\n\tmargin-top: 2px;\n\tfont-family: AppFont, sans-serif;\n\tcolor: var(--ion-color-secondary);\n\tpadding-bottom: 15px;\n\tborder-bottom: 1px solid #d9d9d9;\n}\n\na,\nbutton {\n\ttext-decoration: none;\n\tcolor: black;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\n.lang-row {\n\tfont-size: 20px;\n\tfont-family: AppFont, sans-serif;\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: nowrap;\n}\nion-col {\n\tfont-size: 20px;\n\tcolor: var(--ion-color-secondary);\n}\n\n.selected {\n\topacity: 1 !important;\n}\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n\nion-row {\n\tmargin-top: 6px;\n}\n.header-wrap {\n\tmargin: 10px;\n}\n\n.selected {\n\topacity: 1 !important;\n}\n\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\n\tdiv:first-child {\n\t\tmargin-left: 20px;\n\t}\n\tdiv {\n\t\tmargin: 0px 5px;\n\t\ttext-align: center;\n\t\twidth: 48%;\n\t\t--border-color: var(--ion-color-primary);\n\t\tborder: 2px solid var(--ion-color-primary);\n\t\tbackground: transparent;\n\t\tborder-radius: 50px;\n\t\toverflow: hidden;\n\t\tpadding: 12px 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-weight: bold;\n\t\tspan {\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 14px !important;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tspan {\n\t\t\t\tcolor: white;\n\t\t\t}\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n.footer-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\t.lang-block {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\t.lang-item {\n\t\t\tpadding: 8px 15px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 16px;\n\t\t\tbox-shadow: 0px 3.09px 11.57px 0px #0d47a126;\n\t\t\tmargin-right: 10px;\n\t\t\ttransition: background-color 0.3s ease;\n\t\t\tcursor: pointer;\n\t\t\tion-icon {\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tpadding: 0px;\n\t\t\t}\n\t\t\tbackground: white;\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\tmargin-top: 5px;\n\t\t\t\ttransition: color 0.3s ease;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.logout {\n\t\tzoom: 1.5;\n\t\tmargin: 0px;\n\t}\n}\n.bsg-menu-nav,\n.bsg-legal-nav {\n\tdisplay: flex;\n\tflex-direction: column;\n\ttext-align: left;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbutton {\n\t\tbackground: transparent;\n\t}\n}\n.bsg-menu-item {\n\tdisplay: flex;\n\talign-items: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
